class ViewConstants {
  ETAPA_DATOSCLIENTE = 0;
  ETAPA_PREGUNTASSEGURIDAD = 1;
  ETAPA_LISTADO_SOLICITUDES = 2;
  ETAPA_SELECCION_BANCO = 3;
  ETAPA_NUEVA_PORTABILIDAD = 4;
  ETAPA_PRODUCTOS_A_CONTRATAR = 5;
  ETAPA_RESUMEN_Y_FIRMA = 6;
  ETAPA_FINAL_SOLICITUD = 7;
  ETAPA_CONFIRMACION_PRDUCTOS = 8;
  ETAPA_OFERTA = 9;
  ETAPA_OFERTA_ACEPTADA = 10;
  TAG_MANAGER_API_KEY = process.env.REACT_APP_TAG_MANAGER;
  TOTAL_ETAPAS = 7;
  RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;
  ENABLE_RECAPTCHA = process.env.REACT_APP_ENABLE_RECAPTCHA;
}

const vc = new ViewConstants();
export default vc;
